import ProfileService from '../services/profile.service';

export const profile = {
  namespaced: true,
  state: {
    profileList: [],
  },
  actions: {
    async getProfileList({ commit }) {
      const resp = await ProfileService.getProfileList();
      if (resp.status === 200) {
        commit('SET_PROFILE_LIST', resp.data);
      }
      return resp.status;
    },
    async createProfile(_, newProfile) {
      const resp = await ProfileService.createProfile(newProfile);
      return resp.status;
    },
    async editProfile(_, currentProfile) {
      const resp = await ProfileService.editProfile(currentProfile);
      return resp.status;
    },
    async deleteProfile(_, profileId) {
      const resp = await ProfileService.deleteProfile(profileId);
      return resp.status;
    },
  },
  mutations: {
    SET_PROFILE_LIST(state, profileList) {
      state.profileList = profileList;
    },
  },
};
